// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__bd0GJ"};